/**
 * Premium Mega Menu - AlternativesMG.com
 * Consolidated functionality: Desktop Mega Menus, Dynamic Hover Images, and Mobile Drawer.
 */

class MegaMenu {
    constructor() {
        this.header = document.querySelector('.header-mega-menu');
        this.megaMenuItems = document.querySelectorAll('.has-mega-menu');
        this.init();
    }

    init() {
        this.setupMegaMenuInteractions();
        this.setupDynamicImages();
        console.log('✅ Premium Mega Menu: Desktop components initialized');
    }

    setupMegaMenuInteractions() {
        this.megaMenuItems.forEach(item => {
            const link = item.querySelector('.header-mega-menu__link');
            const megaMenu = item.querySelector('.mega-menu');
            if (!link || !megaMenu) return;

            let closeTimeout;

            item.addEventListener('mouseenter', () => {
                clearTimeout(closeTimeout);
                this.openMenu(megaMenu);
            });

            item.addEventListener('mouseleave', () => {
                closeTimeout = setTimeout(() => this.closeMenu(megaMenu), 300);
            });
        });
    }

    openMenu(menu) {
        menu.style.display = 'block';
        requestAnimationFrame(() => {
            menu.style.opacity = '1';
            menu.style.visibility = 'visible';
            menu.style.transform = 'translateY(0)';
        });
    }

    closeMenu(menu) {
        menu.style.opacity = '0';
        menu.style.visibility = 'hidden';
        menu.style.transform = 'translateY(10px)';
        setTimeout(() => {
            if (menu.style.opacity === '0') menu.style.display = 'none';
        }, 300);
    }

    setupDynamicImages() {
        const hoverLinks = document.querySelectorAll('[data-hover-image]');
        hoverLinks.forEach(linkContainer => {
            const trigger = linkContainer.querySelector('a');
            const hoverSrc = linkContainer.getAttribute('data-hover-image');
            const megaMenu = linkContainer.closest('.mega-menu');
            const promoImage = megaMenu?.querySelector('.mega-menu__promo-image');

            if (!promoImage || !hoverSrc) return;

            const defaultSrc = promoImage.getAttribute('data-default-src');

            trigger.addEventListener('mouseenter', () => {
                promoImage.style.opacity = '0';
                setTimeout(() => {
                    promoImage.src = hoverSrc;
                    promoImage.style.opacity = '1';
                }, 200);
            });

            trigger.addEventListener('mouseleave', () => {
                promoImage.style.opacity = '0';
                setTimeout(() => {
                    promoImage.src = defaultSrc;
                    promoImage.style.opacity = '1';
                }, 200);
            });
        });
    }
}

class MobileDrawer {
    constructor() {
        this.burger = document.querySelector('.header-mega-menu__hamburger');
        this.closeBtn = document.querySelector('.header-mega-menu__drawer-close');
        this.overlay = document.querySelector('.header-mega-menu__overlay');
        this.drawer = document.querySelector('.header-mega-menu__drawer');
        this.toggles = document.querySelectorAll('.header-mega-menu__mobile-toggle, .mobile-column-toggle, .mobile-l2-toggle');

        this.init();
    }

    init() {
        if (!this.burger) return;

        this.burger.addEventListener('click', () => this.toggleDrawer(true));
        this.closeBtn.addEventListener('click', () => this.toggleDrawer(false));
        this.overlay.addEventListener('click', () => this.toggleDrawer(false));

        this.setupAccordions();
        console.log('✅ Premium Mega Menu: Mobile components initialized');
    }

    toggleDrawer(open) {
        document.body.classList.toggle('menu-mobile-open', open);
    }

    setupAccordions() {
        this.toggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                const parent = toggle.closest('.header-mega-menu__mobile-item, .mobile-dropdown-column, .mobile-l2-item');
                if (parent) {
                    parent.classList.toggle('is-open');
                }
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
    new MobileDrawer();
});
